// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { AsyncPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { take } from 'rxjs';
import { PortalWebAppConfigurationService } from '../../services/portal-web-app-configuration.service';
import { AppComponent } from '../app/app.component';

/**
 * root component which clears the splash screen and renders the app
 */
@Component({
  selector: 'app-init',
  templateUrl: './init.component.html',
  standalone: true,
  imports: [AppComponent, AsyncPipe, NgIf],
})
export class InitComponent {
  configReady$ = this.portalWebAppConfiguration.loaded$;
  // Component logic and properties go here
  constructor(
    private portalWebAppConfiguration: PortalWebAppConfigurationService
  ) {
    this.configReady$.pipe(take(1)).subscribe(() => {
      document.body.querySelector('.splash')?.remove();
    });
  }
}
